// src/config/gauges/cotherm4comp.js

export const cotherm4CompGaugeConfig = {
  // ========================
  // TEMPERATURAS
  // ========================
  temperaturas: [
    // 1) Temp Helada In (THI)
    {
      key: "tempHeladaEntrada",
      title: "Temp. Helada Entrada",
      unit: "°C",
      ranges: [
        { from: 0,  to: 8,  color: "red" },    // Rojo
        { from: 8.1,  to: 11, color: "yellow" }, // Amarillo
        { from: 11.1, to: 14, color: "green" },  // Verde
        { from: 14.1, to: 20, color: "yellow" }, // Amarillo
        { from: 20.1, to: 300, color: "red" },    // Rojo
      ],
    },

    // 2) Temp Helada Out (THO)
    {
      key: "tempHeladaSalida",
      title: "Temp. Helada Salida",
      unit: "°C",
      ranges: [
        { from: 0,  to: 4.99,  color: "red" },    // Rojo
        { from: 5,  to: 6.99,  color: "yellow" }, // Amarillo
        { from: 7,  to: 9.99,  color: "green" },  // Verde
        { from: 10,  to: 19.99, color: "yellow" }, // Amarillo
        { from: 20, to: 3000, color: "red" },    // Rojo
      ],
    },

    // 3) Temp Condensación In (TCI)
    {
      key: "tempCondEntrada",
      title: "Temp. Condensación Entrada",
      unit: "°C",
      ranges: [
        { from: 0,  to: 34.99, color: "red" },    // Rojo
        { from: 35, to: 44.99, color: "yellow" }, // Amarillo
        { from: 45, to: 49.99, color: "green" },  // Verde
        { from: 50, to: 54.99, color: "yellow" }, // Amarillo
        { from: 55, to: 80, color: "red" },    // Rojo
      ],
    },

    // 4) Temp Condensación Out (TCO)
    {
      key: "tempCondSalida",
      title: "Temp. Condensación Salida",
      unit: "°C",
      ranges: [
        { from: 0,  to: 44.99, color: "red" },    // Rojo
        { from: 45, to: 54.99, color: "yellow" }, // Amarillo
        { from: 55, to: 59.99, color: "green" },  // Verde
        { from: 60, to: 64.99, color: "yellow" }, // Amarillo
        { from: 65, to: 80, color: "red" },    // Rojo
      ],
    },
  ],

  // ========================
  // SUCCIÓN
  // ========================
  succion: [
    {
      key: "presSuccionComp1",
      title: "Pres. Succion 1",
      unit: "psi",
      ranges: [
        { from: 0,  to: 24.99, color: "red" },
        { from: 25, to: 29.99, color: "yellow" },
        { from: 30, to: 39.99, color: "green" },
        { from: 40, to: 49.99, color: "yellow" },
        { from: 50, to: 1000, color: "red" },
      ],
    },
    {
      key: "presSuccionComp2",
      title: "Pres. Succion 2",
      unit: "psi",
      ranges: [
        { from: 0,  to: 24.99, color: "red" },
        { from: 25, to: 29.99, color: "yellow" },
        { from: 30, to: 39.99, color: "green" },
        { from: 40, to: 49.99, color: "yellow" },
        { from: 50, to: 1000, color: "red" },
      ],
    },
    {
      key: "presSuccionComp3",
      title: "Pres. Succion 3",
      unit: "psi",
      ranges: [
        { from: 0,  to: 24.99, color: "red" },
        { from: 25, to: 29.99, color: "yellow" },
        { from: 30, to: 39.99, color: "green" },
        { from: 40, to: 49.99, color: "yellow" },
        { from: 50, to: 1000, color: "red" },
      ],
    },
    // Nota: lo dejamos simétrico a los demás
    {
      key: "presSuccionComp4",
      title: "Pres. Succion 4",
      unit: "psi",
      ranges: [
       { from: 0,  to: 24.99, color: "red" },
        { from: 25, to: 29.99, color: "yellow" },
        { from: 30, to: 39.99, color: "green" },
        { from: 40, to: 49.99, color: "yellow" },
        { from: 50, to: 1000, color: "red" },
      ],
    },
  ],

  // ========================
  // DESCARGA
  // ========================
  descarga: [
    {
      key: "presionDescargaComp1",
      title: "Pres. Descarga 1",
      unit: "psi",
      ranges: [
        { from: 0,   to: 209.99, color: "red" },
        { from: 210, to: 239.99, color: "yellow" },
        { from: 240, to: 259.99, color: "green" },
        { from: 260, to: 269.99, color: "yellow" },
        { from: 270, to: 3000, color: "red" },
      ],
    },
    {
      key: "presionDescargaComp2",
      title: "Pres. Descarga 2",
      unit: "psi",
      ranges: [
        { from: 0,   to: 209.99, color: "red" },
        { from: 210, to: 239.99, color: "yellow" },
        { from: 240, to: 259.99, color: "green" },
        { from: 260, to: 269.99, color: "yellow" },
        { from: 270, to: 3000, color: "red" },
      ],
    },
    {
      key: "presionDescargaComp3",
      title: "Pres. Descarga 3",
      unit: "psi",
      ranges: [
        { from: 0,   to: 209.99, color: "red" },
        { from: 210, to: 239.99, color: "yellow" },
        { from: 240, to: 259.99, color: "green" },
        { from: 260, to: 269.99, color: "yellow" },
        { from: 270, to: 3000, color: "red" },
      ],
    },
    {
      key: "presionDescargaComp4",
      title: "Pres. Descarga 4",
      unit: "psi",
      ranges: [
        { from: 0,   to: 209.99, color: "red" },
        { from: 210, to: 239.99, color: "yellow" },
        { from: 240, to: 259.99, color: "green" },
        { from: 260, to: 269.99, color: "yellow" },
        { from: 270, to: 3000, color: "red" },
      ],
    },
  ],

  // ========================
  // DIF. ACEITE
  // ========================
  aceite: [
    {
      key: "presionDifAceiteComp1",
      title: "ΔP. Aceite 1",
      unit: "psi",
      ranges: [
        { from: 0,  to: 12, color: "red" },
        { from: 12.1, to: 19.99, color: "yellow" },
        { from: 20, to: 30.99, color: "green" },
        { from: 31, to: 34.99, color: "yellow" },
        { from: 35, to: 60, color: "red" },
      ],
    },
    {
      key: "presionDifAceiteComp2",
      title: "ΔP. Aceite 2",
      unit: "psi",
      ranges: [
        { from: 0,  to: 12, color: "red" },
        { from: 12.1, to: 19.99, color: "yellow" },
        { from: 20, to: 30.99, color: "green" },
        { from: 31, to: 34.99, color: "yellow" },
        { from: 35, to: 60, color: "red" },
      ],
    },
    {
      key: "presionDifAceiteComp3",
      title: "ΔP. Aceite 3",
      unit: "psi",
      ranges: [
        { from: 0,  to: 12, color: "red" },
        { from: 12.1, to: 19.99, color: "yellow" },
        { from: 20, to: 30.99, color: "green" },
        { from: 31, to: 34.99, color: "yellow" },
        { from: 35, to: 60, color: "red" },
      ],
    },
    {
      key: "presionDifAceiteComp4",
      title: "ΔP. Aceite 4",
      unit: "psi",
      ranges: [
        { from: 0,  to: 12, color: "red" },
        { from: 12.1, to: 19.99, color: "yellow" },
        { from: 20, to: 30.99, color: "green" },
        { from: 31, to: 34.99, color: "yellow" },
        { from: 35, to: 60, color: "red" },
      ],
    },
  ],
};
